export default {"src":"/_next/static/media/Cross.6d09545f.svg","height":28,"width":28};